import { useEffect, useState } from "react";
import type { PublicConfig } from "@tih/shared";
import { fetchPublicConfig } from "../api/client";

let cached: PublicConfig | null = null;
let inflight: Promise<PublicConfig> | null = null;

function loadPublicConfig(): Promise<PublicConfig> {
  if (cached) return Promise.resolve(cached);
  if (inflight) return inflight;
  inflight = fetchPublicConfig().then((data) => {
    cached = data;
    return data;
  });
  return inflight;
}

export function usePublicConfig(): PublicConfig | null {
  const [config, setConfig] = useState<PublicConfig | null>(cached);

  useEffect(() => {
    let cancelled = false;
    void loadPublicConfig().then((data) => {
      if (!cancelled) setConfig(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}

export function turnstileRequired(config: PublicConfig | null): boolean {
  return Boolean(config?.turnstileSiteKey);
}
